import {DetailPageConfig} from "@/interfaces/detail-page.interface";

export interface IFilm {
  entity_id: string;
  title: string;
  subtitle?: string;
  director: string;
  year: string;
  duration?: string;
  copyright?: string;
  thumbnail: string;
  description?: string;
  info_text?: string;
  common_keywords: ICommonKeyword[]
  video?: string;
  more_info?: DetailPageConfig.IMoreInfo;
  line_width?: string;
  video_start?: number | null;
  loop_start?: number | null;
  loop_end?: number | null;
  image?: string;
  playerType?: PlayerType;
}

export interface ICommonKeyword {
  entity_id: string
  word: string;
}

export enum PlayerType {
  Html = 'html',
  Vimeo = 'vimeo',
}
